import { log } from "~features/seated-reservation/helpers/stateLogger";
import { setState } from "../index";
import { unsetSeats } from "./unsetSeats";

interface ActionProps {
  seatLabels: string[];
}

export const chartReleaseHold = (payload: ActionProps) => {
  log("chartReleaseHold", payload);

  // This action is triggered when seat holds are released
  // so let's put the chart back into default mode
  setState({
    selectionType: "none",
    selectBestOnChange: true,
  });

  unsetSeats(payload);
};
